/**
 * Copyright (c) 2026-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Remix Icon License v1.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const AlertLine = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="m12.87 3 9.52 16.5a1 1 0 0 1-.86 1.5H2.47a1 1 0 0 1-.86-1.5L11.13 3a1 1 0 0 1 1.74 0M4.2 19h15.58L12 5.5zm6.8-3h2v2h-2zm0-7h2v5h-2z" />
  </Icon>
);
